export const getSelectedDockingPoint = (portVisit) => {
  if (portVisit?.docking_point) return portVisit.docking_point;

  const dockingPointId = portVisit?.docking_point_id;
  if (dockingPointId == null) return null;

  const dockingPoints = Array.isArray(portVisit?.poc_info?.docking_points)
    ? portVisit.poc_info.docking_points
    : [];

  return dockingPoints.find((dock) => String(dock?.id) === String(dockingPointId)) || null;
};

export const formatDockingPointLabel = (dock) => {
  if (!dock) return "Unnamed docking location";

  const name = String(dock?.name || "").trim();
  const dockType = String(dock?.docking_type?.name || "").trim();

  if (name && dockType) return `${name} (${dockType})`;
  if (name) return name;
  if (dockType) return dockType;
  return "Unnamed docking location";
};

export const getEffectivePortLocation = (portVisit) => {
  return getSelectedDockingPoint(portVisit)?.location
    || portVisit?.effective_location
    || portVisit?.poc_info?.location
    || null;
};

export const getEffectivePortCoordinates = (portVisit) => {
  const coordinates = getEffectivePortLocation(portVisit)?.coordinates;
  return Array.isArray(coordinates) && coordinates.length === 2 ? coordinates : null;
};
